import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnlyAuthorizedGuard } from '@services/guards/only-authorized.guard';
import { HasPermissionGuard } from '@services/guards/has-permission.guard';
import { HostCompanyResolverService } from '@services/resolvers/host-company-resolver.service';
import { IntegrationsComponent } from '@web/app/pages/integrations/integrations.component';
import { IntegrationDetailComponent } from './integration-detail/integration-detail.component';
import { IntegrationDetailResolverService, IntegrationNameResolverService, IntegrationResolverService } from '@services/dws';

const routes: Routes = [{
  path: '',
  component: IntegrationsComponent,
  canActivate: [OnlyAuthorizedGuard, HasPermissionGuard],
  resolve: {
    company: HostCompanyResolverService
  }
}, {
  path: ':integrationId',
  component: IntegrationDetailComponent,
  canActivate: [OnlyAuthorizedGuard, HasPermissionGuard],
  resolve: {
    integration: IntegrationResolverService,
    integrationDetails: IntegrationDetailResolverService,
    pageName: IntegrationNameResolverService,
  }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntegrationsRoutingModule { }
